(() => {
  // app/scripts/schneider-selector.js
  var SchneiderSelector = class extends HTMLElement {
    constructor() {
      super();
      this.selectedProducts = [];
      this.responseId = "";
    }
    async connectedCallback() {
      const { buildSearch, loadQueryActions, loadSearchActions } = window.coveoheadless;
      const searchToken = await window.CoveoUtils.getSearchToken();
      if (!searchToken) {
        console.error("Failed to fetch search token");
        return;
      }
      this.engine = window.configureHeadless(searchToken);
      this.dispatch = this.engine.dispatch;
      this.searchController = buildSearch(this.engine);
      this.updateQuery = loadQueryActions(this.engine).updateQuery;
      this.executeSearch = loadSearchActions(this.engine).executeSearch;
      this.searchController.subscribe(() => {
        if (this.responseId === this.searchController.state.responseId) {
          return;
        }
        this.responseId = this.searchController.state.responseId;
        this.addToCart(this.searchController.state.products);
      });
      window.addEventListener("message", this.cnsReceiveMessage.bind(this), false);
    }
    cnsReceiveMessage(event) {
      switch (event.data.fn) {
        case "cnsAddToProject":
          const partsData = JSON.parse(event.data.data);
          const { dispatch, updateQuery, executeSearch } = this;
          if (event.data.IsValid == true) {
            this.selectedProducts = partsData.map((part) => ({
              sku: part.catalogNo,
              quantity: part.quantity
            }));
            const query = `${this.selectedProducts.map((product) => "@sku=" + product.sku).join(" OR ")} `;
            dispatch(updateQuery({ query }));
            dispatch(executeSearch());
          } else {
            console.error("Invalid product selection received.");
          }
          break;
        case "cnsClose":
          if (typeof cnsOverlayClose === "function")
            cnsOverlayClose();
          break;
        case "cnsNestedOpen":
          break;
        case "cnsProdSubset":
          break;
        case "cnsSolution":
          break;
      }
    }
    async addToCart(products) {
      const variantIds = products.map((product) => product.ec_product_id.split("/").pop());
      const data = this.selectedProducts.reduce(
        (accumulator, { sku, quantity }) => {
          const product = products.find((product2) => product2.additionalFields.sku === sku);
          if (product) {
            accumulator.items.push({
              id: Number(product.ec_product_id.split("/").pop()),
              quantity
            });
          }
          return accumulator;
        },
        {
          items: [],
          sections: "drawer-cart-items,header-cart-popup",
          sections_url: `${theme.routes.searchUrl}?q=${variantIds.map((id) => `[variants.id:${id}]`).join(" OR ")}`
        }
      );
      const response = await Cart.add(data);
      if (theme.customer.isB2B) {
        theme.header.cart.update(response).open();
      } else {
        theme.drawers.cart.update(response).open(response.items[0].key);
      }
    }
  };
  customElements.define("schneider-selector", SchneiderSelector);
})();
